import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';
import { CODIGO_CENTRUS } from '../../../../app.constants';
import { DestinacaoReservaCompletoModel } from '../../../shared/models/destinacao-reserva-completo.model';
import { MesAnoModel } from '../../../shared/models/mes-ano.model';
import { PessoaDadosSimplicadosModel } from '../../../shared/models/pessoa-simplificada.model';
import { DR2008CompPdf } from '../../../shared/services/documentos-pdf-imprimir/Plano/destinacao-reserva/dr2008Comp-pdf';
import { PessoaService } from '../../../shared/services/pessoa.service';
import { DateUtilService } from '../../../shared/util/date-util.service';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { DestinacaoReservaService } from '../service/destinacao-reserva.service';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { MessageUtil } from '../../../shared/messages/messageUtil';

@Component({
  selector: 'app-destinacao-reserva-complet-2008',
  templateUrl: './destinacao-reserva-complet-2008.component.html',
  styleUrls: ['./destinacao-reserva-complet-2008.component.css']
})
export class DestinacaoReservaComplet2008Component implements OnInit {

  componentes: any[] = [1];

  destinacaoReservaCompletoModel: DestinacaoReservaCompletoModel = new DestinacaoReservaCompletoModel();

  destinacaoReservaCompletoList: any[] = [];

  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  // 74730 5207460

  @BlockUI() blockUi: NgBlockUI;


  listarMesesAno: Array<any> = new Array<any>();
  mesAno = '';

  cdCentrus: number;
  cdCentrusTit: number;

  descricaoMesAno = ';'
  param: string;
  mensagemSuperior: string;

  mesAno$: Observable<MesAnoModel>;

  mesAnoModel: MesAnoModel = new MesAnoModel();

  constructor(
    private destinacaoReservaService: DestinacaoReservaService,
    private pessoaService: PessoaService,
    private dateUtilService: DateUtilService,
    private store: Store<MesAnoModel>,
    private router: Router,
    private authInterceptor: AuthInterceptor,
    private toastrService: ToastrService,
    private dR2008CompPdf: DR2008CompPdf
  ) {
    this.mesAno$ = this.store.pipe(select('mesAno'));
    this.getMesAno();
  }

  ngOnInit() {

    this.param = 'financeiros/destinacaoR2008';

    this._gerenciarCodigoIndentificao();


  }

  getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {

    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {

        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus()
        }
        this.getPessoasDadosSimplificado();
      })
  }


  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.getCdCentrusTitular();
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }


  getMesAno() {
    this.mesAno$.subscribe(arg => this.mesAnoModel = arg);
  }

  async getCdCentrusTitular() {
    try {
      this.cdCentrusTit = await this.pessoaService.getCdCentrusTitular(this.cdCentrus);
      if (!this.cdCentrusTit) {this.cdCentrusTit = this.cdCentrus};

      this.getObterDestinacaoReservaCompl2008(this.cdCentrus, this.cdCentrusTit, this.mesAnoModel.mes, this.mesAnoModel.ano)
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }

  async getObterDestinacaoReservaCompl2008(cdCentrus: number, cdCentrusTit: number, mes: number, ano: number) {
    try {
      this.descricaoMesAno = this.dateUtilService._carregarDescricaoMesAno(mes, ano);
      const destinacaoReservaComplet = await this.destinacaoReservaService.getObterDestinacaoReservaCompl2008(cdCentrus, cdCentrusTit, mes, ano);

      if (destinacaoReservaComplet === null) {
        this.blockUi.stop();
        this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
        return;
      }

      this.destinacaoReservaCompletoModel = destinacaoReservaComplet;

      this.destinacaoReservaCompletoList = [];

      this.destinacaoReservaCompletoList.push(
        { descricao: `Pagamento Complementar`, valor: destinacaoReservaComplet.vlPagamentoDif });
      this.destinacaoReservaCompletoList.push(
        { descricao: `Valor Devido`, valor: destinacaoReservaComplet.vlPagamento });
      this.destinacaoReservaCompletoList.push(
        { descricao: `Valor Pago em 04/05/2011`, valor: destinacaoReservaComplet.vlPagamentoAnt });
      this.destinacaoReservaCompletoList.push(
        { descricao: `-----------------------------------------------------------`, valor: null });
      this.destinacaoReservaCompletoList.push(
        { descricao: `Diferença a Pagar`, valor: destinacaoReservaComplet.vlPagamentoDif });

      if (destinacaoReservaComplet.vlImposto !== 0
        || destinacaoReservaComplet.vlAdvogado !== 0) {

        this.destinacaoReservaCompletoList.push(
          { descricao: 'Descontos'.toUpperCase(), valor: null });
      }


      if (destinacaoReservaComplet.vlAdvogado !== 0) {
        this.destinacaoReservaCompletoList.push(
          { descricao: `Honorários Advocatícios`, valor: destinacaoReservaComplet.vlAdvogadoDif });
      }
      if (destinacaoReservaComplet.vlImposto) {
        this.destinacaoReservaCompletoList.push(
          { descricao: `Imposto de Renda`, valor: destinacaoReservaComplet.vlImpostoDif });
      }

      this.destinacaoReservaCompletoList.push(
        { descricao: `Valor Líquido do Crédito`, valor: destinacaoReservaComplet.vlLiquidoDif });

    } catch (error) {
      this.toastrService.info('Não foi encontrado destinação reserva para essa data', 'Não foi encontrado', { timeOut: 8000 })
    }
  }

  imprimirPagina() {
    this.dR2008CompPdf.funcionarios(
      this.pessoaDadosSimplicadosModel,
      this.descricaoMesAno,
      this.destinacaoReservaCompletoModel,
      this.destinacaoReservaCompletoList);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/destinacao-reserva/destinacao-reserva-complet-2008/destinacao-reserva-complet-2008.component.ts